import { CalcSupplyPlanService } from './api-services/calc-supply-plan.service';
import { GetSelectInfoService } from './api-services/get-select-info.service';
import { SaveFileService } from './api-services/save-file.service';
import { UpdateReportOutputDateService } from './api-services/update-report-output-date.service';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1102Component } from './kymw1102.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

/**
 * 新規取扱商品画面 モジュール設定クラス
 *
 * @export KYMW1102Module
 * @class KYMW1102Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule
  ],
  declarations: [
    KYMW1102Component,
  ],
  providers: [
    GetSelectInfoService,
    SaveFileService,
    CalcSupplyPlanService,
    UpdateReportOutputDateService
  ],

})
export class KYMW1102Module { }
